import { render, staticRenderFns } from "./GameSystem.vue?vue&type=template&id=6ccf1612&"
import script from "./GameSystem.vue?vue&type=script&lang=js&"
export * from "./GameSystem.vue?vue&type=script&lang=js&"
import style0 from "./GameSystem.vue?vue&type=style&index=0&id=6ccf1612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports